import { render, staticRenderFns } from "./ServerWidget.vue?vue&type=template&id=53253ce0&"
import script from "./ServerWidget.vue?vue&type=script&lang=js&"
export * from "./ServerWidget.vue?vue&type=script&lang=js&"
import style0 from "./ServerWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports